import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { FeeSettingDialogBoxComponent } from '../fee-setting-dialog-box/fee-setting-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-fee-setting',
  templateUrl: './fee-setting.component.html',
  styleUrls: ['./fee-setting.component.scss']
})
export class FeeSettingComponent implements OnInit {
  FeetempSeetingDataSearchForm: FormGroup;
  FeeSettingList: any;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
userPermission
UserCollege
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router,
    private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl; }
  
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    window.scroll(0, 0);
    this.FeetempSeetingDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getFeeSettingData()
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.keypress();
    this.getFeeSettingData();
  }
  
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      let payload = {}
      payload['SearchString'] = this.FeetempSeetingDataSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchFeeTempSetting(payload).subscribe(
        (res) => {
          if(res.status){
            this.FeeSettingList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
          else{
            this.FeeSettingList = [];
            this.totalItems = 0;
          }
        }, (ERROR: HttpErrorResponse) => {
          this.FeeSettingList = [];
        });
    },1000)
   
  }

  getFeeSettingData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege
    this.umsService.getFeeSetting(payload).subscribe(res => {
      this.spinner.hide();
      if(res.status){
        this.spinner.hide();
        this.FeeSettingList = res.data;
        this.totalItems = res.data[0].TotalRecords;
        
      }
      else{
        this.spinner.hide();
        this.FeeSettingList = [];
        this.totalItems = 0;
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.FeeSettingList = [];
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(FeeSettingDialogBoxComponent, {
      width: '75vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getFeeSettingData();
      this.FeetempSeetingDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(FeeSettingDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getFeeSettingData();
      this.FeetempSeetingDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(FeeSettingDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getFeeSettingData();
      this.FeetempSeetingDataSearchForm.controls['SearchString'].setValue('');
    });
  }



}
